import { Component } from '@angular/core';
import { FBAbstractControl } from '../abstract.control';

@Component({
  selector: 'fb-controls-html-content',
  templateUrl: './html-content.component.html',
})
export class FBControlsHTMLContentComponent extends FBAbstractControl {
  constructor() {
    super();
  }

  get html() {
    return 'HTML to be done here';
  }

  static PROPERTIES() {
    return Object.freeze({
      common: {
        ...FBAbstractControl.DefaultProperties(),
      },
      booleans: {
        ...FBAbstractControl.BooleansProperties(),
      },
    });
  }
}
